import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WhitePageComponent } from './white-page.component';

@NgModule({
    declarations: [WhitePageComponent],
    exports: [WhitePageComponent],
    imports: [CommonModule]
})
export class WhitePageModule {}
